import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Button } from '../../components/Button/Primary/Button';
import { Section } from '../../components/Section/Section';
import {
  FreeVideoItemProps,
  VideoItem,
} from '../../components/VideoItem/VideoItem';

export interface FreeVideosSectionProps {
  className?: string;
  videos: FreeVideoItemProps[];
}

const Actions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;

const VISIBLE_VIDEOS = 4;

const FreeVideosSectionInner = (props: FreeVideosSectionProps) => {
  const { videos: allVideos } = props;
  const { t } = useTranslation('translations');
  const [allVisible, setAllVisible] = useState(false);

  const videos = useMemo(() => {
    if (allVisible) {
      return allVideos;
    } else {
      return allVideos.slice(0, VISIBLE_VIDEOS);
    }
  }, [allVisible]);

  return (
    <Section>
      <Container>
        <Grid container className={props.className} wrap="wrap" spacing={4}>
          {videos.map((video, index) => (
            <Grid key={video.url} item sm={6}>
              <VideoItem {...video} />
            </Grid>
          ))}
        </Grid>
        <Actions className="">
          {allVideos.length > VISIBLE_VIDEOS && (
            <Button onClick={() => setAllVisible(!allVisible)}>
              {allVisible ? 'Muestra menos' : 'Mostrar más'}
            </Button>
          )}
        </Actions>
      </Container>
    </Section>
  );
};

export const VideoSection = styled(FreeVideosSectionInner)``;
